'use strict';

import * as progress from '../components/progress';
import modules from '../helpers/modules';
import {callbackOnElements} from '@borngroup/born-utilities';
import {updateTriggersByID, getTriggerData, getTriggerType} from '../wishlist/wishlistUtils';

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function _handleWishlistResponse(response) {
    if (response.success) {
        updateTriggersByID(response.pid, response.type === 'remove', response.listIsEmpty);

        if (response.type !== 'remove') {
            modules.tracking.init(null, {
                trackEvent: 'add_to_wishlist',
                trackObject: {
                    asyncParams: {
                        pid: response.pid,
                        listValue: response.listValue
                    }
                }
            });
        }

    } else if (response.inWishlist) {
        //If `success`` is false, and the item is already in the wishlist, update the trigger to reflect that.
        updateTriggersByID(response.pid);
    }

    progress.hideLoader();
}

/**
 * Requests a Wishlist endpoint call to the server.
 */
function _wishlistRequest(url, pid, options = {}, listValue, useGET) {
    $.ajax({
        url: url,
        type: useGET ? 'GET' : 'POST',
        dataType: 'json',
        data: {
            pid: pid,
            optionId: options.optionId,
            optionVal: options.selectedValueId,
            listValue: listValue
        },
        success: _handleWishlistResponse,
        error: _handleWishlistResponse
    });
}

/**
 * Handles an event (typically a click) on a `wishlist-trigger` element.
 * @param  {[type]} evt [description]
 * @return {[type]}     [description]
 */
function _handleWishlistTrigger(evt) {
    let triggerData = getTriggerData(this),
        url = triggerData.isRemove ? window.SFRA.Urls.wishlistRemoveProduct : window.SFRA.Urls.wishlistAddProduct;

    evt.preventDefault();

    if (!url || !triggerData.pid) {
        return;
    }

    progress.showLoader(this);

    _wishlistRequest(url, triggerData.pid, triggerData.options, triggerData.listValue, triggerData.isRemove);
}

/**
 * Handles the response for the `InWishlist` endpoint request.
 * @param  {[type]} response [description]
 * @return {[type]}          [description]
 */
function _handleInWishlistCheckResponse(response) {
    if (response.success) {
        response.itemsInList.forEach(currentID => updateTriggersByID(currentID));
    }
}

/**
 * Uses `itemList` to request a server check on the items that are already part of the current user's wishlist.
 * @param  {[type]} itemList [description]
 * @return {[type]}          [description]
 */
function _requestInWishlistCheck(itemList) {
    return $.ajax({
        url: window.SFRA.Urls.wishlistInList,
        type: 'POST',
        dataType: 'json',
        data: {
            itemList: JSON.stringify(itemList)
        },
        success: _handleInWishlistCheckResponse
    });
}

/**
 * Initializes `wishlist-trigger` elements.
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
function setupWishlistTriggers(options) {
    let existInWishlist = [];

    callbackOnElements(options.elements, function(currentTrigger) {
        let triggerType = getTriggerType(currentTrigger);

        existInWishlist.push(getTriggerData(currentTrigger));

        currentTrigger.removeAttribute('data-wishlist-trigger');
        currentTrigger.setAttribute('data-wishlist-trigger-ready', triggerType);

        currentTrigger.addEventListener('click', _handleWishlistTrigger);
    });

    return _requestInWishlistCheck(existInWishlist);
}

export const init = setupWishlistTriggers;
